import { Link } from "@tanstack/react-router";
import { ArrowRight, Phone } from "lucide-react";
import chrisPhoto from "@/assets/chris-heidlebaugh-owner-colorado-springs-web-design.png";

export function MeetChrisStrip() {
  return (
    <section className="bg-section-alt py-14 lg:py-20">
      <div className="mx-auto max-w-5xl px-5 lg:px-8">
        <div className="grid gap-8 rounded-2xl border border-border bg-card p-8 shadow-card lg:grid-cols-[auto_1fr] lg:items-center lg:gap-10 lg:p-10">
          <img
            src={chrisPhoto}
            alt="Chris Heidlebaugh, owner of Colorado Web Impressions — Colorado Springs web designer and SEO expert"
            width={400}
            height={400}
            className="h-32 w-32 rounded-full border-4 border-brand-gold/30 object-cover shadow-card lg:h-40 lg:w-40"
            loading="lazy"
            data-geo-lat="38.9359976"
            data-geo-lng="-104.7653118"
            data-geo-city="Colorado Springs"
          />

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-gold-deep">
              Owner-led, not account-managed
            </p>
            <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-foreground sm:text-3xl">
              Work directly with Chris — every project, every call
            </h2>
            <p className="mt-3 text-base leading-relaxed text-foreground/85">
              Chris Heidlebaugh has built and ranked Colorado business websites
              since 2006. Every site we ship, every SEO strategy we deploy, and
              every call you make goes straight to him — no junior account
              manager, no agency middleman.
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <Link
                to="/meet-chris"
                className="inline-flex items-center gap-2 rounded-md bg-gradient-gold px-5 py-3 text-sm font-bold text-brand-black shadow-gold transition-spring hover:-translate-y-0.5"
              >
                Meet Chris <ArrowRight className="h-4 w-4" />
              </Link>
              <a
                href="tel:+17194193935"
                className="inline-flex items-center gap-2 rounded-md border-2 border-foreground/20 bg-card px-5 py-3 text-sm font-bold text-foreground transition-smooth hover:border-brand-gold/60 hover:text-brand-gold-deep"
                aria-label="Call Chris at (719) 419-3935"
              >
                <Phone className="h-4 w-4" /> (719) 419-3935
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
